const blur = {
  none: 0,
  "ms-4": "4px",
  "ms-8": "8px",
  "ms-12": "12px",
  "ms-16": "16px",
  "ms-24": "24px",
  "ms-40": "40px",
  "ms-64": "64px",
};

export default blur;
